module.exports = __webpack_public_path__ + "static/media/img-01.6b9bd0ba.jpg";